import { User } from 'shared/types';
import {
  ExternalFeatureLayer,
  ExternalFeatureLayerName,
} from './mapping.types';

export const getExternalFeatureLayerId = (
  featureLayer: ExternalFeatureLayer,
  user: User | null,
): ExternalFeatureLayerName | null => {
  const organizationId = user?.organizations?.[0]?.id;
  if (!organizationId) {
    return null;
  }
  return `organization_${organizationId}_${featureLayer.shortName}` as ExternalFeatureLayerName;
};
